// Petits comportements du thème Finisher Board. Rien n'est indispensable : sans JavaScript,
// le site reste lisible (menu ouvert par le lien, contenus visibles, panier fonctionnel).
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Menu mobile */
  all('[data-menu-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(open ? 'data-label-close' : 'data-label-open'));
      btn.classList.toggle('is-open', open);
      panel.hidden = !open;
    });
  });

  /* Apparition douce des blocs au défilement */
  var reveals = all('[data-reveal]');
  if (reveals.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -60px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
    }
  }

  /* Sur écran tactile (pas de survol) : les animations des cartes se jouent une fois à l'apparition */
  if (touch && 'IntersectionObserver' in window) {
    var play = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-play', 'true');
          play.unobserve(e.target);
        }
      });
    }, { threshold: 0.6 });
    all('[data-card]').forEach(function (el) { play.observe(el); });
  }

  /* Compte à rebours jusqu'à la date limite (AAAA-MM-JJ, jusqu'à 23 h 59 heure du visiteur) */
  all('[data-countdown]').forEach(function (el) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('data-countdown') || '');
    if (!m) return;
    var end = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    function tick() {
      var left = end.getTime() - Date.now();
      if (left <= 0) {
        el.textContent = el.getAttribute('data-text-over') || '';
        return false;
      }
      var d = Math.floor(left / 86400000);
      var h = Math.floor((left % 86400000) / 3600000);
      var mi = Math.floor((left % 3600000) / 60000);
      el.innerHTML = '';
      var time = document.createElement('time');
      time.setAttribute('datetime', end.toISOString());
      time.textContent = el.getAttribute('data-text-prefix') + ' ' + d + ' ' + el.getAttribute('data-text-days') + ' ' +
        pad(h) + ' ' + el.getAttribute('data-text-hours') + ' ' + pad(mi) + ' ' + el.getAttribute('data-text-minutes');
      el.appendChild(time);
      return true;
    }
    if (tick()) setInterval(tick, 30000);
  });

  /* Sentier en pointillés des étapes : il se dessine au fil du défilement (grand écran) */
  all('[data-trail]').forEach(function (wrap) {
    var svg = wrap.querySelector('.how__trail');
    if (!svg) return;
    function update() {
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var p = reduce ? 1 : Math.min(1, Math.max(0, (vh * 0.85 - r.top) / Math.max(1, r.height * 0.9)));
      svg.style.clipPath = 'inset(-40px ' + ((1 - p) * 100).toFixed(1) + '% -40px 0)';
    }
    update();
    if (!reduce) {
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
  });

  /* Panier : boutons − et + (le formulaire se renvoie tout seul) */
  all('#cart-form').forEach(function (form) {
    var timer = 0;
    function send() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var u = document.createElement('input');
        u.type = 'hidden';
        u.name = 'update';
        u.value = '1';
        form.appendChild(u);
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }, 450);
    }
    all('[data-qty-step]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('[data-qty-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
        input.value = next;
        send();
      });
    });
    all('[data-qty-input]', form).forEach(function (input) {
      input.addEventListener('change', send);
    });
  });

  /* Carte cadeau : champs du destinataire */
  all('[data-gift-toggle]').forEach(function (box) {
    var fields = document.querySelector('[data-gift-fields]');
    var offset = document.querySelector('[data-gift-offset]');
    if (offset) offset.value = String(new Date().getTimezoneOffset());
    if (!fields) return;
    function sync() {
      fields.hidden = !box.checked;
      all('input, textarea', fields).forEach(function (f) {
        if (f.type !== 'hidden') f.disabled = !box.checked;
      });
    }
    box.addEventListener('change', sync);
    sync();
  });
  /* Filtres de la boutique (boutons Tous, En stock, Personnalisé…) */
  all('[data-filters]').forEach(function (bar) {
    var list = document.querySelector('[data-filter-list]');
    var empty = document.querySelector('[data-filter-empty]');
    if (!list) return;
    var buttons = all('[data-filter-btn]', bar);
    function apply(key) {
      var shown = 0;
      all('.cards__item', list).forEach(function (li) {
        var card = li.querySelector('[data-card]');
        var tags = card ? (card.getAttribute('data-filter') || '').split(' ') : [];
        var ok = key === 'all' || tags.indexOf(key) !== -1;
        li.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-filter-btn') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-filter-btn')); });
    });
  });
})();
